import '../../core/components/app-root/AppRoot.css';
import './SplitLayout.css';
export var column = '_6q8dk21-3-8-0';
export var contentShellContainer = '_6q8dk23-3-8-0 _6q8dk21-3-8-0';
export var handleColumn = '_6q8dk24-3-8-0 _6q8dk21-3-8-0';
export var handleDecorations = '_6q8dk25-3-8-0';
export var layout = '_6q8dk20-3-8-0';
export var panelShellContainer = '_6q8dk22-3-8-0 _6q8dk21-3-8-0';
export var resizeHandle = '_6q8dk26-3-8-0';